import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form'
import { PERFIL_ADMIN, getAdminEmpresa, getFiscalEmbarque, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Moment from 'react-moment';
import selecionarDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/selecionarDisponibilidadeVeiculo';

export class CalendarioDisponibilidadeVeiculo extends Component {

    exibeAtivo = () => {
        return (
            <input type="checkbox" value={true} checked={true} readOnly={true} />
        );
    }

    render() {
        return <div className="geral">
            <div className="resumo">
                <div className="row">
                    <div className="col"><Moment format="DD/MM/YYYY">{this.props.disponibilidadeVeiculo.dataInicio}</Moment> à <Moment format="DD/MM/YYYY">{this.props.disponibilidadeVeiculo.dataFim}</Moment></div>
                    <div className="col">
                        {this.exibeAtivo()}
                    </div>
                    <div className="col">{this.props.disponibilidadeVeiculo.categoriasDisponibilidadeVeiculo.length > 0 ? this.props.disponibilidadeVeiculo.categoriasDisponibilidadeVeiculo[0].categoria.valor : ''}</div>
                    <div id='container-botoes' className="col-sm-2 mr-md-n4">
                        <div className='dropdown'>
                            <span className="titulo-mobile">Ações:</span>
                            <button id='menu3pontos' className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="material-icons">
                                    &#xe5d4;
                                </i>
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <div className="botoes">
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                                        getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                                        <button type="button" className="btn btn-editar " title='Editar Calendário'
                                            onClick={() => {
                                                this.props.selecionarDisponibilidadeVeiculo(this.props.disponibilidadeVeiculo);
                                                this.props.history.push('/painel-cadastro-calendario-disponibilidade-veiculo')
                                            }}>
                                            <i className="material-icons nav-icon">&#xe150;</i>
                                        </button>
                                    </Autorizacao>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                                        getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                                        <button id='buttonExcluir' type="button" className="btn ml-2" title='Excluir Calendário'
                                            data-toggle="modal"
                                            data-target="#modalConfirmacaoExclusaoDisponibilidadeVeiculo"
                                            onClick={() => {
                                                this.props.selecionarDisponibilidadeVeiculo(this.props.disponibilidadeVeiculo);
                                            }}>
                                            <svg id='excluirCalendario' xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                                            </svg>
                                        </button>
                                    </Autorizacao>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
    });

export default withRouter(connect(mapStateToProps, {
    selecionarDisponibilidadeVeiculo
})(reduxForm({
    form: 'formularioCalendarioDisponibilidadeVeiculo'
})(CalendarioDisponibilidadeVeiculo)))